// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"Input_inputContainer__2sCc9","rightBlock":"Input_rightBlock__1BRih","label":"Input_label__3zMt9","inputError":"Input_inputError__x7cEn"};